// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"AQ-z","inlineTitle":"BQ-z","sponsoredAdsWrapper":"CQ-z","marketplaceRecosWrapper":"DQ-z"};